import { useEffect, useState } from 'react';

import { TenantSettingService } from '../../he-thong/tham-so-he-thong/TenantSettingService';

export const SINH_SO_SAU_ENABLED_VALUE = 'K';

export const isMttInvoiceSerial = (invoiceSerial?: string): boolean =>
  Boolean(
    invoiceSerial &&
      invoiceSerial.length >= 4 &&
      invoiceSerial[3].toUpperCase() === 'M',
  );

export const useSinhSoSauInvoiceEnabled = (invoiceSerial?: string) => {
  const [sinhSoSauEnabled, setSinhSoSauEnabled] = useState(false);
  const [sinhSoSauMttEnabled, setSinhSoSauMttEnabled] = useState(false);

  useEffect(() => {
    Promise.all([
      TenantSettingService.getList({
        key: TenantSettingService.key.SINH_SO_SAU,
      }),
      TenantSettingService.getList({
        key: TenantSettingService.key.SINH_SO_SAU_MAY_TINH_TIEN,
      }),
    ]).then(([sinhSoSauRes, sinhSoSauMttRes]) => {
      if (sinhSoSauRes.items?.length > 0) {
        setSinhSoSauEnabled(
          sinhSoSauRes.items[0].value === SINH_SO_SAU_ENABLED_VALUE,
        );
      }

      if (sinhSoSauMttRes.items?.length > 0) {
        setSinhSoSauMttEnabled(
          sinhSoSauMttRes.items[0].value === SINH_SO_SAU_ENABLED_VALUE,
        );
      }
    });
  }, []);

  return isMttInvoiceSerial(invoiceSerial)
    ? sinhSoSauMttEnabled
    : sinhSoSauEnabled;
};
